import { Typography } from '@mui/material';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import VerificationInput from 'react-verification-input';
import { Button, Modal } from '../../../components';
import {
  confirmNotificationChannel,
  profileSlice,
  useDispatch,
  useSelector,
} from '../../../stores';
import { palette } from '../../../theme';
import { handleApiReturn, handleErrors } from '../../../utils';
import {
  StyledButtonsWrapper,
  StyledInputWrapper,
  StyledStepWrapper,
  StyledTextWrapper,
} from '../styles';
import { validationCodeSchema } from '../validations';

const getChannelLabel = (typeId: number | null) => {
  switch (typeId) {
    case 1:
      return 'SMS';
    case 2:
      return 'e-mail';
    case 3:
      return 'WhatsApp';
    default:
      return 'canal selecionado';
  }
};

export const ActivateNotificationChannelModal: React.FC = () => {
  const dispatch = useDispatch();
  const {
    notificationChannelModalIsOpen,
    notificationChannelLoading,
    pendingNotificationTypeId,
    notificationChannelDestination,
  } = useSelector((state) => state.profileReducer);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [code, setCode] = useState('');

  const handleClose = () => {
    setCode('');
    setErrors({});
    dispatch(profileSlice.actions.closeNotificationChannelModal());
  };

  const handleConfirm = () => {
    if (!pendingNotificationTypeId) {
      return;
    }

    setErrors({});
    validationCodeSchema
      .validate({ code }, { abortEarly: false })
      .then(() =>
        dispatch(
          confirmNotificationChannel({
            driverId: localStorage.getItem('NITROT:driverId') || '',
            notificationType: pendingNotificationTypeId,
            code,
          }),
        ).then((res: any) => {
          handleApiReturn(
            res,
            () => {
              toast.success('Canal de notificação atualizado com sucesso.');
              handleClose();
            },
            null,
          );
        }),
      )
      .catch((err) => {
        setErrors(handleErrors(err));
      });
  };

  return (
    <Modal
      open={notificationChannelModalIsOpen}
      onClose={handleClose}
      title='Confirmar canal de notificação'
    >
      <StyledStepWrapper>
        <StyledTextWrapper>
          <Typography
            color='primary'
            textAlign='center'
            variant='h6'
            gutterBottom
          >
            Código enviado com sucesso!
          </Typography>
          <Typography color={palette.text.main} textAlign='center' gutterBottom>
            Digite o código de 6 dígitos enviado para{' '}
            {getChannelLabel(pendingNotificationTypeId)}
            {notificationChannelDestination
              ? `: ${notificationChannelDestination}`
              : ''}
          </Typography>
        </StyledTextWrapper>
        <StyledInputWrapper>
          <VerificationInput
            validChars='0-9'
            inputProps={{ inputMode: 'numeric' }}
            onChange={(value) => setCode(value)}
          />
          <Typography
            color={palette.error.main}
            textAlign='center'
            gutterBottom
            marginTop={1}
            height={10}
          >
            {errors.code}
          </Typography>
        </StyledInputWrapper>
        <StyledButtonsWrapper>
          <Button
            variant='contained'
            label='Confirmar'
            type='submit'
            onClick={handleConfirm}
            color='secondary'
            loading={notificationChannelLoading}
            style={{ width: '100%' }}
          />
        </StyledButtonsWrapper>
      </StyledStepWrapper>
    </Modal>
  );
};
